export default __webpack_public_path__ + "static/media/discord.77bce117.jpg";